// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1_9ua","toggle":"styles_toggle__xv1lr","preview":"styles_preview__uRG5R"};